/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetCandidateDetailsResponseDto } from '../models';
// @ts-ignore
import type { GetCandidateStatusResponseDto } from '../models';
// @ts-ignore
import type { GetNextPrevCandidateResponseDto } from '../models';
// @ts-ignore
import type { PickCandidatesRequestDto } from '../models';
// @ts-ignore
import type { ReprocessSelectedCandidatesRequestDto } from '../models';
// @ts-ignore
import type { UpdateCandidateRateRequestDto } from '../models';
// @ts-ignore
import type { UpdateProcessCandidateDetailsRequestDto } from '../models';
/**
 * ProcessesCandidatesRestApi - axios parameter creator
 */
export const ProcessesCandidatesRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a candidate
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProcessCandidate: async (processId: string, candidateApplicationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('deleteProcessCandidate', 'processId', processId)
            // verify required parameter 'candidateApplicationId' is not null or undefined
            assertParamExists('deleteProcessCandidate', 'candidateApplicationId', candidateApplicationId)
            const localVarPath = `/api/v1/processes/{processId}/candidate-applications/{candidateApplicationId}`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{candidateApplicationId}', encodeURIComponent(String(candidateApplicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get CV of a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateApplicationCv: async (processId: string, candidateApplicationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getCandidateApplicationCv', 'processId', processId)
            // verify required parameter 'candidateApplicationId' is not null or undefined
            assertParamExists('getCandidateApplicationCv', 'candidateApplicationId', candidateApplicationId)
            const localVarPath = `/api/v1/processes/{processId}/candidate-applications/{candidateApplicationId}/cv`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{candidateApplicationId}', encodeURIComponent(String(candidateApplicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/pdf';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get details of a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateApplicationDetails: async (processId: string, candidateApplicationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getCandidateApplicationDetails', 'processId', processId)
            // verify required parameter 'candidateApplicationId' is not null or undefined
            assertParamExists('getCandidateApplicationDetails', 'candidateApplicationId', candidateApplicationId)
            const localVarPath = `/api/v1/processes/{processId}/candidate-applications/{candidateApplicationId}`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{candidateApplicationId}', encodeURIComponent(String(candidateApplicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get candidate application status
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateApplicationStatus: async (processId: string, candidateApplicationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getCandidateApplicationStatus', 'processId', processId)
            // verify required parameter 'candidateApplicationId' is not null or undefined
            assertParamExists('getCandidateApplicationStatus', 'candidateApplicationId', candidateApplicationId)
            const localVarPath = `/api/v1/processes/{processId}/candidate-applications/{candidateApplicationId}/status`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{candidateApplicationId}', encodeURIComponent(String(candidateApplicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {GetNextPrevCandidateApplicationCandidateDirectionEnum} candidateDirection 
         * @param {number} currentPosition 
         * @param {number} [searchId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextPrevCandidateApplication: async (processId: string, candidateApplicationId: string, candidateDirection: GetNextPrevCandidateApplicationCandidateDirectionEnum, currentPosition: number, searchId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getNextPrevCandidateApplication', 'processId', processId)
            // verify required parameter 'candidateApplicationId' is not null or undefined
            assertParamExists('getNextPrevCandidateApplication', 'candidateApplicationId', candidateApplicationId)
            // verify required parameter 'candidateDirection' is not null or undefined
            assertParamExists('getNextPrevCandidateApplication', 'candidateDirection', candidateDirection)
            // verify required parameter 'currentPosition' is not null or undefined
            assertParamExists('getNextPrevCandidateApplication', 'currentPosition', currentPosition)
            const localVarPath = `/api/v1/processes/{processId}/candidate-applications/{candidateApplicationId}/next`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{candidateApplicationId}', encodeURIComponent(String(candidateApplicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (candidateDirection !== undefined) {
                localVarQueryParameter['candidateDirection'] = candidateDirection;
            }

            if (searchId !== undefined) {
                localVarQueryParameter['searchId'] = searchId;
            }

            if (currentPosition !== undefined) {
                localVarQueryParameter['currentPosition'] = currentPosition;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Pick a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pickCandidateApplication: async (processId: string, candidateApplicationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('pickCandidateApplication', 'processId', processId)
            // verify required parameter 'candidateApplicationId' is not null or undefined
            assertParamExists('pickCandidateApplication', 'candidateApplicationId', candidateApplicationId)
            const localVarPath = `/api/v1/processes/{processId}/candidate-applications/{candidateApplicationId}/pick`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{candidateApplicationId}', encodeURIComponent(String(candidateApplicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Pick candidates
         * @param {string} processId 
         * @param {PickCandidatesRequestDto} pickCandidatesRequestDto Candidates details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pickCandidates: async (processId: string, pickCandidatesRequestDto: PickCandidatesRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('pickCandidates', 'processId', processId)
            // verify required parameter 'pickCandidatesRequestDto' is not null or undefined
            assertParamExists('pickCandidates', 'pickCandidatesRequestDto', pickCandidatesRequestDto)
            const localVarPath = `/api/v1/processes/{processId}/candidates/pick`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pickCandidatesRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reprocess a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reprocessCandidateApplication: async (processId: string, candidateApplicationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('reprocessCandidateApplication', 'processId', processId)
            // verify required parameter 'candidateApplicationId' is not null or undefined
            assertParamExists('reprocessCandidateApplication', 'candidateApplicationId', candidateApplicationId)
            const localVarPath = `/api/v1/processes/{processId}/candidate-applications/{candidateApplicationId}/reprocess`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{candidateApplicationId}', encodeURIComponent(String(candidateApplicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reprocess selected candidates
         * @param {string} processId 
         * @param {ReprocessSelectedCandidatesRequestDto} reprocessSelectedCandidatesRequestDto Candidates details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reprocessSelectedCandidates: async (processId: string, reprocessSelectedCandidatesRequestDto: ReprocessSelectedCandidatesRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('reprocessSelectedCandidates', 'processId', processId)
            // verify required parameter 'reprocessSelectedCandidatesRequestDto' is not null or undefined
            assertParamExists('reprocessSelectedCandidates', 'reprocessSelectedCandidatesRequestDto', reprocessSelectedCandidatesRequestDto)
            const localVarPath = `/api/v1/processes/{processId}/candidates/reprocess-selected-candidates`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reprocessSelectedCandidatesRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update details of a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {UpdateProcessCandidateDetailsRequestDto} updateProcessCandidateDetailsRequestDto Update candidate details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCandidateApplicationDetails: async (processId: string, candidateApplicationId: string, updateProcessCandidateDetailsRequestDto: UpdateProcessCandidateDetailsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateCandidateApplicationDetails', 'processId', processId)
            // verify required parameter 'candidateApplicationId' is not null or undefined
            assertParamExists('updateCandidateApplicationDetails', 'candidateApplicationId', candidateApplicationId)
            // verify required parameter 'updateProcessCandidateDetailsRequestDto' is not null or undefined
            assertParamExists('updateCandidateApplicationDetails', 'updateProcessCandidateDetailsRequestDto', updateProcessCandidateDetailsRequestDto)
            const localVarPath = `/api/v1/processes/{processId}/candidate-applications/{candidateApplicationId}`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{candidateApplicationId}', encodeURIComponent(String(candidateApplicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProcessCandidateDetailsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update candidate application rate
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {UpdateCandidateRateRequestDto} updateCandidateRateRequestDto Candidate rate details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCandidateApplicationRate: async (processId: string, candidateApplicationId: string, updateCandidateRateRequestDto: UpdateCandidateRateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateCandidateApplicationRate', 'processId', processId)
            // verify required parameter 'candidateApplicationId' is not null or undefined
            assertParamExists('updateCandidateApplicationRate', 'candidateApplicationId', candidateApplicationId)
            // verify required parameter 'updateCandidateRateRequestDto' is not null or undefined
            assertParamExists('updateCandidateApplicationRate', 'updateCandidateRateRequestDto', updateCandidateRateRequestDto)
            const localVarPath = `/api/v1/processes/{processId}/candidate-applications/{candidateApplicationId}/rate`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{candidateApplicationId}', encodeURIComponent(String(candidateApplicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCandidateRateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessesCandidatesRestApi - functional programming interface
 */
export const ProcessesCandidatesRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProcessesCandidatesRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a candidate
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProcessCandidate(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProcessCandidate(processId, candidateApplicationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCandidatesRestApi.deleteProcessCandidate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get CV of a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidateApplicationCv(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidateApplicationCv(processId, candidateApplicationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCandidatesRestApi.getCandidateApplicationCv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get details of a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidateApplicationDetails(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCandidateDetailsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidateApplicationDetails(processId, candidateApplicationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCandidatesRestApi.getCandidateApplicationDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get candidate application status
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidateApplicationStatus(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCandidateStatusResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidateApplicationStatus(processId, candidateApplicationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCandidatesRestApi.getCandidateApplicationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {GetNextPrevCandidateApplicationCandidateDirectionEnum} candidateDirection 
         * @param {number} currentPosition 
         * @param {number} [searchId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNextPrevCandidateApplication(processId: string, candidateApplicationId: string, candidateDirection: GetNextPrevCandidateApplicationCandidateDirectionEnum, currentPosition: number, searchId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNextPrevCandidateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNextPrevCandidateApplication(processId, candidateApplicationId, candidateDirection, currentPosition, searchId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCandidatesRestApi.getNextPrevCandidateApplication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Pick a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pickCandidateApplication(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pickCandidateApplication(processId, candidateApplicationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCandidatesRestApi.pickCandidateApplication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Pick candidates
         * @param {string} processId 
         * @param {PickCandidatesRequestDto} pickCandidatesRequestDto Candidates details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pickCandidates(processId: string, pickCandidatesRequestDto: PickCandidatesRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pickCandidates(processId, pickCandidatesRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCandidatesRestApi.pickCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reprocess a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reprocessCandidateApplication(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reprocessCandidateApplication(processId, candidateApplicationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCandidatesRestApi.reprocessCandidateApplication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reprocess selected candidates
         * @param {string} processId 
         * @param {ReprocessSelectedCandidatesRequestDto} reprocessSelectedCandidatesRequestDto Candidates details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reprocessSelectedCandidates(processId: string, reprocessSelectedCandidatesRequestDto: ReprocessSelectedCandidatesRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reprocessSelectedCandidates(processId, reprocessSelectedCandidatesRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCandidatesRestApi.reprocessSelectedCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update details of a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {UpdateProcessCandidateDetailsRequestDto} updateProcessCandidateDetailsRequestDto Update candidate details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCandidateApplicationDetails(processId: string, candidateApplicationId: string, updateProcessCandidateDetailsRequestDto: UpdateProcessCandidateDetailsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCandidateApplicationDetails(processId, candidateApplicationId, updateProcessCandidateDetailsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCandidatesRestApi.updateCandidateApplicationDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update candidate application rate
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {UpdateCandidateRateRequestDto} updateCandidateRateRequestDto Candidate rate details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCandidateApplicationRate(processId: string, candidateApplicationId: string, updateCandidateRateRequestDto: UpdateCandidateRateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCandidateApplicationRate(processId, candidateApplicationId, updateCandidateRateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCandidatesRestApi.updateCandidateApplicationRate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProcessesCandidatesRestApi - factory interface
 */
export const ProcessesCandidatesRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProcessesCandidatesRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a candidate
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProcessCandidate(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteProcessCandidate(processId, candidateApplicationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get CV of a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateApplicationCv(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getCandidateApplicationCv(processId, candidateApplicationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get details of a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateApplicationDetails(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetCandidateDetailsResponseDto> {
            return localVarFp.getCandidateApplicationDetails(processId, candidateApplicationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get candidate application status
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateApplicationStatus(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetCandidateStatusResponseDto> {
            return localVarFp.getCandidateApplicationStatus(processId, candidateApplicationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {GetNextPrevCandidateApplicationCandidateDirectionEnum} candidateDirection 
         * @param {number} currentPosition 
         * @param {number} [searchId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextPrevCandidateApplication(processId: string, candidateApplicationId: string, candidateDirection: GetNextPrevCandidateApplicationCandidateDirectionEnum, currentPosition: number, searchId?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetNextPrevCandidateResponseDto> {
            return localVarFp.getNextPrevCandidateApplication(processId, candidateApplicationId, candidateDirection, currentPosition, searchId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Pick a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pickCandidateApplication(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.pickCandidateApplication(processId, candidateApplicationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Pick candidates
         * @param {string} processId 
         * @param {PickCandidatesRequestDto} pickCandidatesRequestDto Candidates details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pickCandidates(processId: string, pickCandidatesRequestDto: PickCandidatesRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.pickCandidates(processId, pickCandidatesRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reprocess a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reprocessCandidateApplication(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reprocessCandidateApplication(processId, candidateApplicationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reprocess selected candidates
         * @param {string} processId 
         * @param {ReprocessSelectedCandidatesRequestDto} reprocessSelectedCandidatesRequestDto Candidates details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reprocessSelectedCandidates(processId: string, reprocessSelectedCandidatesRequestDto: ReprocessSelectedCandidatesRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reprocessSelectedCandidates(processId, reprocessSelectedCandidatesRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update details of a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {UpdateProcessCandidateDetailsRequestDto} updateProcessCandidateDetailsRequestDto Update candidate details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCandidateApplicationDetails(processId: string, candidateApplicationId: string, updateProcessCandidateDetailsRequestDto: UpdateProcessCandidateDetailsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCandidateApplicationDetails(processId, candidateApplicationId, updateProcessCandidateDetailsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update candidate application rate
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {UpdateCandidateRateRequestDto} updateCandidateRateRequestDto Candidate rate details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCandidateApplicationRate(processId: string, candidateApplicationId: string, updateCandidateRateRequestDto: UpdateCandidateRateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCandidateApplicationRate(processId, candidateApplicationId, updateCandidateRateRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessesCandidatesRestApi - interface
 */
export interface ProcessesCandidatesRestApiInterface {
    /**
     * 
     * @summary Delete a candidate
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteProcessCandidate(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get CV of a candidate application
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCandidateApplicationCv(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Get details of a candidate application
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCandidateApplicationDetails(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetCandidateDetailsResponseDto>;

    /**
     * 
     * @summary Get candidate application status
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCandidateApplicationStatus(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetCandidateStatusResponseDto>;

    /**
     * 
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {GetNextPrevCandidateApplicationCandidateDirectionEnum} candidateDirection 
     * @param {number} currentPosition 
     * @param {number} [searchId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNextPrevCandidateApplication(processId: string, candidateApplicationId: string, candidateDirection: GetNextPrevCandidateApplicationCandidateDirectionEnum, currentPosition: number, searchId?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetNextPrevCandidateResponseDto>;

    /**
     * 
     * @summary Pick a candidate application
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pickCandidateApplication(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Pick candidates
     * @param {string} processId 
     * @param {PickCandidatesRequestDto} pickCandidatesRequestDto Candidates details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pickCandidates(processId: string, pickCandidatesRequestDto: PickCandidatesRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Reprocess a candidate application
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reprocessCandidateApplication(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Reprocess selected candidates
     * @param {string} processId 
     * @param {ReprocessSelectedCandidatesRequestDto} reprocessSelectedCandidatesRequestDto Candidates details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reprocessSelectedCandidates(processId: string, reprocessSelectedCandidatesRequestDto: ReprocessSelectedCandidatesRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update details of a candidate application
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {UpdateProcessCandidateDetailsRequestDto} updateProcessCandidateDetailsRequestDto Update candidate details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCandidateApplicationDetails(processId: string, candidateApplicationId: string, updateProcessCandidateDetailsRequestDto: UpdateProcessCandidateDetailsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update candidate application rate
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {UpdateCandidateRateRequestDto} updateCandidateRateRequestDto Candidate rate details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCandidateApplicationRate(processId: string, candidateApplicationId: string, updateCandidateRateRequestDto: UpdateCandidateRateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * ProcessesCandidatesRestApi - object-oriented interface
 */
export class ProcessesCandidatesRestApi extends BaseAPI implements ProcessesCandidatesRestApiInterface {
    /**
     * 
     * @summary Delete a candidate
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteProcessCandidate(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig) {
        return ProcessesCandidatesRestApiFp(this.configuration).deleteProcessCandidate(processId, candidateApplicationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get CV of a candidate application
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCandidateApplicationCv(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig) {
        return ProcessesCandidatesRestApiFp(this.configuration).getCandidateApplicationCv(processId, candidateApplicationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get details of a candidate application
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCandidateApplicationDetails(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig) {
        return ProcessesCandidatesRestApiFp(this.configuration).getCandidateApplicationDetails(processId, candidateApplicationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get candidate application status
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCandidateApplicationStatus(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig) {
        return ProcessesCandidatesRestApiFp(this.configuration).getCandidateApplicationStatus(processId, candidateApplicationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {GetNextPrevCandidateApplicationCandidateDirectionEnum} candidateDirection 
     * @param {number} currentPosition 
     * @param {number} [searchId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNextPrevCandidateApplication(processId: string, candidateApplicationId: string, candidateDirection: GetNextPrevCandidateApplicationCandidateDirectionEnum, currentPosition: number, searchId?: number, options?: RawAxiosRequestConfig) {
        return ProcessesCandidatesRestApiFp(this.configuration).getNextPrevCandidateApplication(processId, candidateApplicationId, candidateDirection, currentPosition, searchId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Pick a candidate application
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public pickCandidateApplication(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig) {
        return ProcessesCandidatesRestApiFp(this.configuration).pickCandidateApplication(processId, candidateApplicationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Pick candidates
     * @param {string} processId 
     * @param {PickCandidatesRequestDto} pickCandidatesRequestDto Candidates details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public pickCandidates(processId: string, pickCandidatesRequestDto: PickCandidatesRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesCandidatesRestApiFp(this.configuration).pickCandidates(processId, pickCandidatesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reprocess a candidate application
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reprocessCandidateApplication(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig) {
        return ProcessesCandidatesRestApiFp(this.configuration).reprocessCandidateApplication(processId, candidateApplicationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reprocess selected candidates
     * @param {string} processId 
     * @param {ReprocessSelectedCandidatesRequestDto} reprocessSelectedCandidatesRequestDto Candidates details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reprocessSelectedCandidates(processId: string, reprocessSelectedCandidatesRequestDto: ReprocessSelectedCandidatesRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesCandidatesRestApiFp(this.configuration).reprocessSelectedCandidates(processId, reprocessSelectedCandidatesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update details of a candidate application
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {UpdateProcessCandidateDetailsRequestDto} updateProcessCandidateDetailsRequestDto Update candidate details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCandidateApplicationDetails(processId: string, candidateApplicationId: string, updateProcessCandidateDetailsRequestDto: UpdateProcessCandidateDetailsRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesCandidatesRestApiFp(this.configuration).updateCandidateApplicationDetails(processId, candidateApplicationId, updateProcessCandidateDetailsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update candidate application rate
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {UpdateCandidateRateRequestDto} updateCandidateRateRequestDto Candidate rate details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCandidateApplicationRate(processId: string, candidateApplicationId: string, updateCandidateRateRequestDto: UpdateCandidateRateRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesCandidatesRestApiFp(this.configuration).updateCandidateApplicationRate(processId, candidateApplicationId, updateCandidateRateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

export const GetNextPrevCandidateApplicationCandidateDirectionEnum = {
    Next: 'NEXT',
    Prev: 'PREV',
} as const;
export type GetNextPrevCandidateApplicationCandidateDirectionEnum = typeof GetNextPrevCandidateApplicationCandidateDirectionEnum[keyof typeof GetNextPrevCandidateApplicationCandidateDirectionEnum];
